import React from "react";
import i18n from '../../locales/i18n';
import PdfLayout from '../PdfLayout';
import PdfLayoutWidget from './PdfLayoutWidget';
import { Screen } from '../../services';

/** Class representing a PDF layout image widget. */
class LibraryImageWidget extends PdfLayoutWidget {

    constructor(properties) {
        super({
            ...(LibraryImageWidget.getDefaultOptions()),
            ...properties,
            type: PdfLayout.IMAGE,
            subType: PdfLayout.LIBRARY_IMAGE
        });
    }

    /**
     * Get this widget default options
     */
    static getDefaultOptions() {
        return {
            position: { x: 2, y: 2, z: 0 },
            dimensions : { width: 4, height: 4 },
            transform: { rotation: 0 },
            options: {
                type: 'logo-a4',
                style: {
                    align: 'center',
                    objectFit: "contain",
                    borderStyle: 'solid',
                    borderWidth: 0,
                    borderColor: '#000000',
                    borderRadius: 0,
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    }
                },
            }
        };
    }

    /**
     * Return the list of options this widget handles
     */
    getHandledOptions() {
        return super.getHandledOptions().concat([
            PdfLayout.OPTION_OBJECT_FIT,
            PdfLayout.OPTION_ALIGNMENT,
            PdfLayout.OPTION_IMAGE_TYPE,
            PdfLayout.OPTION_PADDING,
        ]);
    }

    /**
     * Return this widget preview as JSX string
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {String} lang
     *                 - {Object} setting
     */
    getPreview(props) {
        const { setting, lang, inEdition } = props;

        const image = setting?.findImage(this.options?.type, lang);
        const borderWidth = parseFloat(this.options?.style?.borderWidth) || 0;
        const borderRadius = this.options?.style?.borderRadius || 0;
        const frameRadius = borderWidth > 0 ? borderRadius : 0;

        const imageStyle = {
            width: '100%',
            height: '100%',
        };
        if (this.options.style?.objectFit === 'cover' ||
            this.options.style?.objectFit === 'contain') {
            imageStyle.objectFit = this.options.style?.objectFit;
        };

        return (
            <div style={{
                textAlign: this.options?.style?.align,
                width: Screen.cmToPx(this.dimensions?.width),
                height: Screen.cmToPx(this.dimensions?.height),
                overflow: 'hidden',
                backgroundColor: this.options?.style?.backgroundColor,
                border: `${borderWidth}px ${this.options?.style?.borderStyle} ${this.options?.style?.borderColor}`,
                borderRadius: `${frameRadius}px`,
                paddingTop: `${Screen.cmToPx(this.options?.style?.padding?.top || 0)}px`,
                paddingRight: `${Screen.cmToPx(this.options?.style?.padding?.right || 0)}px`,
                paddingBottom: `${Screen.cmToPx(this.options?.style?.padding?.bottom || 0)}px`,
                paddingLeft: `${Screen.cmToPx(this.options?.style?.padding?.left || 0)}px`,
                boxSizing: 'border-box',
            }}>
                { image?.rfc2397_data && (
                    <>
                        <img ref={props.ref} src={ image.rfc2397_data } style={ imageStyle } alt={i18n.t('layouts.alt_library_media')} />
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0
                        }} />
                    </>
                )}

                { !image?.rfc2397_data && (
                    <div style={{
                        backgroundColor: '#565656',
                        width: Screen.cmToPx(this.dimensions?.width) - (inEdition ? 2 : 0),
                        height: Screen.cmToPx(this.dimensions?.height) - (inEdition ? 2 : 0),
                    }} />
                )}

            </div>
        );
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'photo';
    }
}

export default LibraryImageWidget;
